var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"m-background m-background--media-1"}),_vm._v(" "),_c('div',{staticClass:"m-background__overlay"}),_vm._v(" "),_c('img',{staticClass:"m-logo m-logo--top-right",attrs:{"src":require("@/assets/images/rics-logo.png")}}),_vm._v(" "),_c('div',{staticClass:"l-container"},[_c('ConfidenceSurvey'),_vm._v(" "),_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f91ef584","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Confidence.vue
// module id = null
// module chunks = 